import React from "react";
import { useLocation, useRouteMatch } from "react-router-dom";
import AppPaths from "../../../constants/appPaths";

interface IDataObjectDuplicateSearchPageBreadcrumbProps {
    setBreadcrumbNavigationItems?: (b: IBreadcrumbItem[]) => void;
    onBackToList: () => void;
}

/**
 * Manage breadcrumb based on the URL location and hash
 */
export default function DataObjectDuplicateSearchPageBreadcrumb({ setBreadcrumbNavigationItems, onBackToList }: IDataObjectDuplicateSearchPageBreadcrumbProps) {
    const location = useLocation();
    const match = useRouteMatch<{ tenant: string }>();
    const hashRef = React.useRef<string>();

    React.useEffect(() => {
        if (!location?.hash && hashRef.current !== location?.hash) {
            // Hash has been removed from URL, return to list
            onBackToList();
        }
        // Save as reference for refresh
        hashRef.current = location?.hash;

        return () => {
            hashRef.current = undefined;
        };
    }, [location?.hash, onBackToList]);

    React.useEffect(() => {
        if (setBreadcrumbNavigationItems) {
            const breadcrumbNavigationItems = [
                {
                    route: AppPaths.TENANT_HOME.replace(":tenant", match.params.tenant.toLowerCase()),
                    text: "Home",
                },
                {
                    route: AppPaths.TENANT_DATA_OBJECT_DUPLICATE_SEARCH.replace(":tenant", match.params.tenant.toLowerCase()),
                    text: "Search Duplicates",
                },
            ];
            if (location?.hash) {
                const hashValue = decodeURIComponent(location.hash).slice(1);
                const idOnly = hashValue.split("?")[0];
                breadcrumbNavigationItems.push({
                    route: `${AppPaths.TENANT_DATA_OBJECT_DUPLICATE_SEARCH.replace(":tenant", match.params.tenant.toLowerCase())}${location.hash}`,
                    text: idOnly,
                });
            }
            setBreadcrumbNavigationItems(breadcrumbNavigationItems);
        }
    }, [location, match, setBreadcrumbNavigationItems]);

    return <></>;
}
